import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const EventsRoutes: RouteBundle = {
  domain: 'events',
  routes: [
    {
      urlPattern: 'event-subscriptions',
      handler: EditorRoutes.eventSubscriptionsPage.bind(EditorRoutes),
      legacy: true,
    },
  ],
};
